__webpack_require__.p = "https://bmidxbbelgiumnlplpreprod.netlify.app/";